import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import dayjs from "dayjs";
import { baseURL } from "services/api";
import { MyBookedRefferalsProps, MyBookingProps } from "./types";

const baseQuery = fetchBaseQuery({
  baseUrl: `${baseURL}`,
  prepareHeaders: (headers) => {
    headers.set("Accept", "application/json");
    headers.set("Content-Type", "application/json");
    return headers;
  },
});

export const bookingApi = createApi({
  reducerPath: "bookingService",
  baseQuery,
  endpoints: (builder) => ({
    getMyBookings: builder.query<any, MyBookingProps>({
      query: ({ business_id, date }) => {
        let endpoint = `/booking/business/${business_id}`;
        const params = new URLSearchParams();
        
        if (date) {
          const dateString = date instanceof Date
            ? dayjs(date).format("YYYY-MM-DD")
            : date;
          params.append('date', dateString);
        }
        
        params.append('limit', '100');
        params.append('page', '1');
        
        const queryString = params.toString();
        if (queryString) {
          endpoint += `?${queryString}`;
        }
        
        return { url: endpoint, method: "GET" };
      },
    }),

    getMyBookedReferrals: builder.query<any, MyBookedRefferalsProps>({
      query: ({ user_id, date }) => {
        let endpoint = `/booking/bookedReferrals/${user_id}`;
        const params = new URLSearchParams();
        
        if (date) {
          const dateString = date instanceof Date
            ? dayjs(date).format("YYYY-MM-DD")
            : date;
          params.append('date', dateString);
        }
        
        params.append('limit', '100');
        params.append('page', '1');
        
        const queryString = params.toString();
        if (queryString) {
          endpoint += `?${queryString}`;
        }
        
        return { url: endpoint, method: "GET" };
      },
    }),

    getBookingDetails: builder.query<any, string | number>({
      query: (detailsId) => ({
        url: `/booking/details/${detailsId}`,
        method: "GET",
      }),
    }),

    cancelBooking: builder.mutation<any, string | number>({
      query: (booking_id) => ({
        url: `/booking/fareharbor/${booking_id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const { 
  useLazyGetMyBookingsQuery, 
  useLazyGetMyBookedReferralsQuery, 
  useGetBookingDetailsQuery, 
  useCancelBookingMutation 
} = bookingApi;